import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';
import { openNotificationsDrawer } from '@capital-access/common/actions';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { NavConfig, NavConfigFn, NavigationConfigProvider } from '@capital-access/common/navigation';

@Injectable()
export class AlertsNavConfigProvider implements NavigationConfigProvider {
  constructor(private store: Store) {}

  resolveNavConfig: NavConfigFn = () => {
    return combineLatest([this.store.select(getFeatureToggle('notification-center'))]).pipe(
      map(
        isNotificationCenterEnabled =>
          <NavConfig>{
            mobileEntity: isNotificationCenterEnabled
              ? [
                  {
                    localizationKey: 'notificationCenter',
                    icon: 'f-i-bell',
                    order: -1,
                    action: openNotificationsDrawer()
                  }
                ]
              : []
          }
      )
    );
  };
}
